export default __webpack_public_path__ + "static/media/Thumb_Glasses_04.a5772a7c.png";